import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateUserProfile } from '@api/userProfile';

import { IOnClose } from '@interfaces/common/handlers';
import { IUpdateUserProfileDTO } from '@interfaces/user/dto/userProfileDTO';

import { ESnackbarTypes } from '@enums/common';

import { UPDATE_USER_PROFILE, USER_PROFILE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateManageUserProfile = ({ onClose }: IOnClose) => {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: editUserProfile,
		isLoading: isLoadingEditUserProfile,
	} = useMutation<IUpdateUserProfileDTO>({
		mutationKey: [UPDATE_USER_PROFILE],
		mutationFn: updateUserProfile,
		onSuccess: () => {
			if (onClose) onClose();

			dispatch(setSnackbar({
				message: responseMessages.updateUserProfile,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([USER_PROFILE])];
		},
	});

	return {
		editUserProfile,
		isLoadingEditUserProfile,
	};
};
